import React, { useEffect, useState } from "react";
import { Box, Tooltip } from "@material-ui/core";
import UserProfileWidget from "../../../widgets/UserProfileWidget";
import { get } from "lodash";
import { useStyles } from "../styles";
import { checkArrayLength } from "../../../../utils";
import CoachesList from "../../../formControls/Popovers/CoachesList";
import {
  USER_FIRSTNAME,
  USER_LASTNAME,
} from "../../../../constants/literalConstant";

const TargetAssignedToList = (colProps) => {
  const [state, setState] = useState({});
  const classes = useStyles();
  useEffect(() => {
    const assigneeList = [
      ...((colProps.dataItem.targetUser && colProps.dataItem.targetUser.items
        ? colProps.dataItem.targetUser.items
        : colProps.dataItem.targetUser) || []),
    ];
    const showAssignee = [...(assigneeList || [])].splice(0, 3);
    const popOverAssignee = [...assigneeList]
      .splice(3, assigneeList.length)
      .map((i) => {
        const tempUser = { ...i };
        tempUser.coach = { ...i.user };
        delete tempUser.user;
        return tempUser;
      });
    setState({ showAssignee, popOverAssignee });
  }, []);
  return (
    <td style={{ width: 150 }}>
      <Box
        display="flex"
        className={classes.coachesInfo}
        alignItems="flex-start"
      >
        <Box display={"flex"} alignItems="center">
          {checkArrayLength(get(state, "showAssignee", []))
            ? get(state, "showAssignee", []).map((res, key) => {
                return (
                  <Tooltip title={get(res, USER_FIRSTNAME, "")} key={key}>
                    <Box className={classes.coachProfileOverlap}>
                      <UserProfileWidget
                        firstName={get(res, USER_FIRSTNAME, "")}
                        lastName={get(res, USER_LASTNAME, "")}
                        url={get(res, "user.profileImage.fileName", "")}
                      />
                    </Box>
                  </Tooltip>
                );
              })
            : "-"}
        </Box>
        {checkArrayLength(state.popOverAssignee) ? (
          <CoachesList userList={state.popOverAssignee} />
        ) : null}
      </Box>
    </td>
  );
};

export default TargetAssignedToList;
